// import React, { useEffect, useState } from 'react';
// import Form from 'components/Form/FormComponents/Form';
// import { cutStepDetails } from '../cutStepDetails';
// import Column from 'components/Grid/Column';
// import RadioCheckbox from 'components/Form/FormComponents/RadioCheckbox';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

// const CutLegendControl = ({
//     handleFilterSubmit,
//     inputs,
//     setInputs,
// }) => {
//     const [selectedState, setSelectedState] = useState(false);

//     const toggleSelected = (e) => {
//         setSelectedState(!selectedState);
//         let value = e.target.value;
//         if (value === "all") {
//             delete inputs.step;
//             setInputs(inputs);
//         } else {
//             setInputs({...inputs, step: value});
//         }
//     }

//     useEffect(() => {
//         handleFilterSubmit();
//     }, [selectedState]);

//     return (
//         <>
//             <div className="leaflet-bottom leaflet-right">
//                 <div className='leaflet-control info legend'>
//                     <Form values={inputs} setValues={setInputs} style={{paddingTop: '0'}}>
//                             {cutStepDetails.map(({ label, value, color }) => {
//                                 return (
//                                     <Column width={1/5} key={label}>
//                                         <RadioCheckbox
//                                             id={`${label + '-' + value}`}
//                                             name="radio-button"
//                                             label={label}
//                                             value={label}
//                                             iconLeft={(<FontAwesomeIcon icon={solid('map-marker-alt')} style={{color: color}} />)}
//                                             style={{marginRight:'10px', marginLeft:'10px'}}
//                                             selected={selectedState}
//                                             onClick={(e) => toggleSelected(e)}
//                                         />
//                                     </Column>
//                                 );
//                             })}
//                             <Column width={5/5}>
//                                 <RadioCheckbox
//                                     id="all"
//                                     name="radio-button"
//                                     label="View All"
//                                     value="all"
//                                     iconLeft={(<FontAwesomeIcon icon={solid('eye')} style={{color: '#0065c4'}} />)}
//                                     style={{marginRight:'10px', marginLeft:'10px'}}
//                                     selected={selectedState}
//                                     onClick={(e) => toggleSelected(e)}
//                                 />
//                             </Column>
//                     </Form>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default CutLegendControl;

import React, { useEffect, useRef } from 'react';
import Form from 'components/Form/FormComponents/Form';
import { cutStepDetails } from '../cutStepDetails';
import Column from 'components/Grid/Column';
import RadioCheckbox from 'components/Form/FormComponents/RadioCheckbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

const CutLegendControl = ({
    handleFilterSubmit,
    inputs,
    setInputs,
}) => {
    const hasMounted = useRef(false);

    const toggleSelected = (value) => {
        if (value === "all") {
            const newInputs = {...inputs};
            delete newInputs.step;
            setInputs(newInputs);
        } else {
            setInputs({...inputs, step: value});
        }
    };

    useEffect(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }
        handleFilterSubmit();
    }, [inputs.step]);

    return (
        <>
            <div className="leaflet-bottom leaflet-right">
                <div className='leaflet-control info legend'>
                    <Form values={inputs} setValues={setInputs} style={{paddingTop: '0'}}>
                        {cutStepDetails.map(({ label, value, color }) => (
                            <Column width={1/5} key={label}>
                                <RadioCheckbox
                                    id={`${label}-${value}`}
                                    name="radio-button"
                                    label={label}
                                    value={label}
                                    checked={inputs.step === label}
                                    iconLeft={<FontAwesomeIcon icon={solid('map-marker-alt')} style={{color: color}} />}
                                    style={{marginRight:'10px', marginLeft:'10px'}}
                                    onClick={() => toggleSelected(label)}
                                />
                            </Column>
                        ))}
                        <Column width={5/5}>
                            <RadioCheckbox
                                id="all"
                                name="radio-button"
                                label="View All"
                                value="all"
                                checked={!inputs.step}
                                iconLeft={<FontAwesomeIcon icon={solid('eye')} style={{color: '#0065c4'}} />}
                                style={{marginRight:'10px', marginLeft:'10px'}}
                                onClick={() => toggleSelected("all")}
                            />
                        </Column>
                    </Form>
                </div>
            </div>
        </>
    );
};

export default CutLegendControl;